<template>
  <div class="data-empty">
    <img :src="noDataImg" />
    <p class="text">
      <slot>暂无数据</slot>
    </p>
  </div>
</template>
<script>
export default {
  name: "data-empty",
  data() {
    return {
      noDataImg: require("../assets/images/no_data.svg"),
    };
  },
};
</script>
<style lang="scss" scoped >
.data-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.text {
  margin-top: 40px;
  text-align: center;
  color: #898B97;
}
</style>